import { COLORS } from '@gate31/core/src/libs/colors';
import { buildBackgroundColorProduct } from '@gate31/core/src/libs/utils';
import { InsalesProduct } from '../InsalesProduct/InsalesProduct';

// todo Использовать с фильтрах

export interface ColorInfoObjInt {
    id: number;
    url: string;
    colorName: string;
    background: string | undefined;
}

// todo Существующие методы стоит сделать статичными.
// todo Если this.product не используется - выпилить. Или нам нужен методы которы возвращает background текущего продукта?

export class ProductColor {
    product: InsalesProduct;

    constructor({ product }: { product: InsalesProduct }) {
        this.product = product;
    }

    getBackgroundByColorName(colorName: string) {
        const hexColor = COLORS.find(elem => elem.title === colorName)?.hex;

        if (hexColor?.length) {
            return buildBackgroundColorProduct(hexColor);
        }

        // todo Возможно передавать в сентри чтобы знать что отсутствуют используемые цвета
    }

    transformColorObject(ProductList: Array<InsalesProduct>): ColorInfoObjInt[] {
        return ProductList.map(product => {
            return {
                id: product.id,
                url: product.product.url,
                colorName: product.getColorName() ?? '',
                background: this.getBackgroundByColorName(product.getColorName() ?? '')
            };
        });
    }
}
